import { createReducer } from "./functions";

import { SET_ABSENCE_TYPES } from "../../modules/presence/actions/presence";

const initialState = [];

const setActionsList = {
  [SET_ABSENCE_TYPES]: (state, action) => {
    return action.payload;
  }
};
const actionsReducer = createReducer(initialState, {
  ...setActionsList
});

export default actionsReducer;



// WEBPACK FOOTER //
// src/redux/reducers/absenceTypesReducer.js